// extracted by mini-css-extract-plugin
export default {"content":"footer_content__8GpF5","left_side":"footer_left_side__XRkBZ","location":"footer_location__4hOiu","link":"footer_link__a8fUV"};